export default __webpack_public_path__ + "static/media/bq-bo.45c5ccf2.svg";